import React, { useMemo } from "react";
import { PopoverInteractionKind, PopoverPosition, MenuItem } from "@blueprintjs/core";
import { Tooltip } from "@blueprintjs/core";
import { omit } from "lodash";
import classNames from "classnames";
import { checkPressedEnter } from "utils/keyboard";
import Loader from "../../../Loader";
import * as styles from "./styles.module.scss";
const DefaultThreeDotsMenuItem = ({ text, message, icon, onClick, classes, disabled, isLoading, children, closeMenuOnClick, }) => {
    const preparedIcon = useMemo(() => !icon || typeof icon === "string" ? (icon) : (React.createElement("div", { className: classNames(styles.customIcon, classes?.iconClassName) }, icon)), [icon, classes?.iconClassName]);
    const tooltip = useMemo(() => message
        ? {
            labelElement: (React.createElement(Tooltip, { minimal: true, content: message, popoverClassName: styles.tooltip, position: PopoverPosition.LEFT, openOnTargetFocus: false, renderTarget: (props) => (React.createElement("div", { ...omit(props, "isOpen"), className: classNames(styles.tooltipTarget, props.className) },
                    React.createElement(React.Fragment, null))) })),
            labelClassName: styles.tooltipTargetWrapper,
        }
        : {}, [message]);
    const textComponent = useMemo(() => (React.createElement(React.Fragment, null,
        React.createElement("span", null, text),
        isLoading && React.createElement(Loader, { className: styles.loader }))), [text, isLoading]);
    return (React.createElement(MenuItem, { disabled: disabled || isLoading, className: classNames(styles.menuItem, classes?.className, {
            [styles.disabled]: disabled || isLoading,
        }), text: textComponent, textClassName: styles.textWrapper, icon: preparedIcon, onClick: (e) => {
            onClick && onClick(e);
            closeMenuOnClick && closeMenuOnClick();
        }, onKeyDown: (e) => {
            if (checkPressedEnter(e) && onClick) {
                onClick(e);
            }
        }, popoverProps: {
            popoverClassName: styles.submenu,
            shouldReturnFocusOnClose: true,
            usePortal: true,
            interactionKind: PopoverInteractionKind.CLICK,
        }, ...tooltip }, children));
};
export default DefaultThreeDotsMenuItem;
